import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Typography from "@mui/material/Typography";
import { useI18n } from "@/i18n/I18nProvider";
import en from "../../../locales/common/en";

const steps = ["", "", "", ""];

export default function HorizontalNonLinearStepper() {
  const { t, locale } = useI18n();

  const [activeStep, setActiveStep] = useState(0);

  const handleStep = (step) => () => {
    setActiveStep(step);
  };
  const autoIncrementStep = () => {
    setActiveStep((prevStep) =>
      prevStep === steps.length - 1 ? 0 : prevStep + 1
    );
  };

  useEffect(() => {
    const interval = setInterval(autoIncrementStep, 4000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const contentGen = ({ title, heading, text, img, idx }) => (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: {
          xs: "column",
          sm: "row",
        },
        justifyContent: { xlg: "space-around" },
        alignItems: {
          xs: "start",
        },
        color: "white",
        mx: {
          xs: 2,
          md: 4,
        },
      }}
      id="instant-approval"
    >
      <Box
        data-aos="fade-up"
        data-aos-delay="100"
        sx={{
          width: {
            xs: "100%",
            lg: "90%",
            md: "80%",
            sm: "100%",
          },
        }}
      >
        <Box
          sx={{
            mb:
              idx == 0
                ? { xs: 36, md: 40 }
                : idx == 1
                ? { xs: 26, md: 28 }
                : idx == 2
                ? { xs: 16, md: 18 }
                : idx == 3
                ? { xs: 6, md: 8 }
                : idx == 4
                ? -2
                : 0,
            mt:
              idx == 0
                ? { xs: 4, sm: 0, lg: 5 }
                : idx == 1
                ? { xs: 14, sm: 10, md: 12, lg: 17 }
                : idx == 2
                ? { xs: 24, sm: 20, md: 22, lg: 27 }
                : idx == 3
                ? locale === "en"
                  ? { xs: 31, sm: 30, md: 32, lg: 37 }
                  : { xs: 34, sm: 30, md: 32, lg: 37 }
                : idx == 4
                ? { xs: 42, sm: 38, md: 42, lg: 47 }
                : 0,
          }}
        >
          <Typography
            variant="h4"
            component="h3"
            sx={{
              fontSize: { xs: "20px", sm: "20px", md: "25px", lg: "30px" },
              mb: { md: 1 },
            }}
          >
            {heading}
          </Typography>
          <Typography
            variant="body"
            sx={{
              fontSize: { xs: "10px", sm: "12px", md: "16px" },
            }}
          >
            {text}
          </Typography>
        </Box>
        <Box
          sx={{
            mr: locale === "ar" ? { xs: -6, md: -8 } : "",
            ml: locale === "en" ? { xs: -6, md: -8 } : "",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              marginTop: "1%",
            }}
          >
            <Box
              sx={{
                mb: 2,
              }}
            >
              <a
                href={t.home_page.slides[1].app?.google_play_link}
                target="_blank"
              >
                <Box
                  component="img"
                  sx={{
                    width: { xs: "80px", md: "100px", lg: "140px" },
                    height: { xs: "30px", md: "35px", lg: "45px" },
                    cursor: "pointer",
                    mt: {
                      xs: 1,
                      md: 1,
                    },
                  }}
                  src={
                    t === en
                      ? "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-google-play.webp"
                      : "/googleplay-ar.svg"
                  }
                  alt="google-play"
                  loading="lazy"
                />
              </a>
              <a
                href={t.home_page.slides[1].app.app_store_link}
                target="_blank"
              >
                <Box
                  component="img"
                  sx={{
                    width: { xs: "80px", md: "100px", lg: "140px" },
                    height: { xs: "30px", md: "35px", lg: "45px" },
                    mx: {
                      xs: 1,
                      md: 2,
                    },
                    mt: {
                      xs: 1,
                      md: 1,
                    },
                    cursor: "pointer",
                  }}
                  src={
                    t === en
                      ? "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-app-store.webp"
                      : "/appstore-ar.svg"
                  }
                  alt="home-app-store"
                  loading="lazy"
                />
              </a>
            </Box>

            <Box>
              <Box
                component="img"
                alt="qrcode"
                sx={{
                  width: { xs: "50px", md: "60px", lg: "100px" },
                  height: { xs: "50px", md: "60px", lg: "100px" },
                }}
                src={t.home_page.slides[1].app.qr_code}
                loading="lazy"
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            height: "450px",
            width: "450px",
            borderRadius: "50%",
            backgroundImage: "url('https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/circle.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "absolute",
            zIndex: "-1",
            transform: "translate(-50%, -50%)",
            top: "50%",
            left: "50%",
            display: { xs: "none", md: "initial" },
          }}
        ></Box>
        <Box
          component="img"
          sx={{
            margin: {
              md: "inherit",
              xs: "auto",
            },
            width: {
              xs: "200px",
              sm: "250px",
              md: "275px",
              xl: "300px",
            },
            height: {
              sm: "400px",
              md: "450px",
              lg: "500px",
              xl: "600px",
            },
            objectFit: "cover",
            display: {
              xs: "none",
              sm: "block",
            },
          }}
          src={img}
          alt="steps"
          loading="lazy"
        />
      </Box>
    </Box>
  );

  const extractContent = (idx) => {
    return contentGen({
      title: t.stepsFeature_business[idx].subTitle,
      heading: t.stepsFeature_business[idx].title,
      text: t.stepsFeature_business[idx].text,
      img: t.stepsFeature_business[idx].img,
      idx,
    });
  };

  return (
    <>
      <Box
        className="stepper-box"
        sx={{
          backgroundColor: "#282780",
          backgroundImage: "url('https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/layer.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          py: 4,
          height: { xs: "200px", sm: "500px", md: "500px", lg: "700px" },
          color: "white",
          height: { xs: "200px", sm: "350px", md: "500px", lg: "700px" },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          gap: 6,
          position: "relative",
          py: { xs: 35, sm: 20 },
          overflow: "hidden",
          height: { xs: "200px", sm: "500px", md: "600px", lg: "700px" },
        }}
      >
        <Box
          sx={{
            right: {
              xs: 0,
              md: locale === "en" ? 0 : "10%",
            },
            left: {
              xs: 0,
              md: locale === "en" ? "10%" : 0,
            },
            top: {
              xs: "5%",
              md: "20%",
            },
            display: "flex",
            mt: { xs: -30, sm: 0 },
            px: { xs: 2, md: 8 },
            zIndex: 9,
            width: "100%",
          }}
        >
          <Box
            alt="logo"
            component="img"
            src={
              locale == "en"
                ? "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brokerage-en.webp"
                : "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brokerage-ar.png"
            }
            sx={{
              maxWidth: { xs: "60px", lg: "120px" },
              display: { xs: "block", sm: "none", lg: "block" },
              mt: 3,
              mb: 5,
            }}
            style={{
              position: "absolute",
              top: "2px",
            }}
          ></Box>
          <Stepper
            className="pick"
            sx={{
              display: "block",
              zIndex: 9,
              pt: { xs: 4, sm: 0, lg: 6 },
            }}
            nonLinear
            activeStep={activeStep}
            orientation={"vertical"}
          >
            {steps.map((label, index) => (
              <Step key={index}>
                <StepButton
                  aria-label={`Step ${index + 1} for Insurance Brokerage`}
                  color="inherit"
                  sx={{
                    py: { xs: 0.5, md: 1 },
                    display: "flex",
                    justifyContent: "center",
                  }}
                  onClick={handleStep(index)}
                ></StepButton>
              </Step>
            ))}
          </Stepper>
          {extractContent(activeStep)}
        </Box>
      </Box>
    </>
  );
}
